/**
 * TermsCtrl controller
 * Show terms
 */

/**
 * TermsCtrl controller
 * Opens modal when user click on 'Term' link
 *
 * @class TermsCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:TermsCtrl
 */
/* @ngInject */
export default function TermsCtrl ($uibModalInstance) {
  var vm = this

  /**
   * Close modal window with terms
   *
   * @memberof mwApp/auth.controller:TermsCtrl
   */
  vm.close = function () {
    $uibModalInstance.close()
  }
}
